import { ItemCard } from "@coworker/apprestructured/src/shared/components/item-cards/ItemCard/ItemCard";
import { ItemStockAndEds } from "@coworker/apprestructured/src/shared/components/item-cards/ItemStockAndEds/ItemStockAndEds";
import { ItemDelivery } from "@coworker/apprestructured/src/shared/components/item-cards/ItemDelivery/ItemDelivery";
import { ItemLocation } from "@coworker/apprestructured/src/shared/components/item-cards/ItemLocation/ItemLocation";
import { Item } from "@coworker/apprestructured/src/shared/types/item";
import styles from "./item-list-view-item-card.module.css";
import { Spacer } from "@coworker/apprestructured/src/shared/components/Spacer/Spacer";
import { ItemLastRefill } from "@coworker/apprestructured/src/shared/components/item-cards/ItemLastRefill/ItemLastRefill";
import { ItemImage } from "@coworker/apprestructured/src/shared/components/item-cards/ItemImage/ItemImage";
import { ItemNoWithCopy } from "@coworker/apprestructured/src/shared/components/item-cards/ItemNoWithCopy/ItemNoWithCopy";
import { ItemDescription } from "@coworker/apprestructured/src/shared/components/item-cards/ItemDescription/ItemDescription";
import { ItemName } from "@coworker/apprestructured/src/shared/components/item-cards/ItemName/ItemName";

interface ItemListViewItemCardProps {
  item: Item;
  lastRefilled: string;
  lastRefilledQuantity: number;
  homeLocationGridCode: string;
  refillLocationGridCode: string;
}

export const ItemListViewItemCard = ({
  item,
  lastRefilledQuantity,
  lastRefilled,
  homeLocationGridCode,
  refillLocationGridCode,
}: ItemListViewItemCardProps) => {
  const refillLocationBadge = [
    {
      text: refillLocationGridCode,
      color: "blue",
    },
  ];
  return (
    <ItemCard badges={refillLocationBadge}>
      <div className={styles["item-card-root-row"]}>
        <ItemImage imageUrl={item.imageUrl || ""} />
        <div className={styles["item-card-root-column"]}>
          <ItemName name={item.name} />
          <ItemNoWithCopy itemNo={item.noFormatted} />
          <ItemDescription description={item.description || ""} />
          <Spacer />
          <ItemLocation locationGridCode={homeLocationGridCode} />
          <Spacer />
          <ItemLastRefill
            lastRefilledDate={lastRefilled}
            lastRefilledQuantity={lastRefilledQuantity}
          />
          <ItemStockAndEds itemNo={item.no} itemType={item.type} />
          <ItemDelivery itemNo={item.no} />
        </div>
      </div>
    </ItemCard>
  );
};
